import{f as c,m as e}from"./chunk-HBP5N4FR.js";var f=c((b,o)=>{e();function r(t){var n=typeof t;return t!=null&&(n=="object"||n=="function")}o.exports=r});export{f as a};
//# sourceMappingURL=chunk-35YX2WD6.js.map
